// src/components/skills/SkillSection.js
import React from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";
import { useTranslation } from "react-i18next";

import DataScienceImg from "./DataScienceImg";
import FullStackImg from "./FullStackImg";
import CloudInfraImg from "./CloudInfraImg";
import DesignImg from "./DesignImg";

function GetSkillSvg({ fileName, theme }) {
  if (fileName === "DataScienceImg") return <DataScienceImg theme={theme} />;
  if (fileName === "FullStackImg") return <FullStackImg theme={theme} />;
  if (fileName === "CloudInfraImg") return <CloudInfraImg theme={theme} />;
  return <DesignImg theme={theme} />;
}

function SkillSection({ theme }) {
  const { t } = useTranslation();

  return (
    <div>
      {skills.data.map((skill, i) => (
        <div key={i} className="skills-main-div">
          <Fade left duration={2000}>
            <div className="skills-image-div">
              <GetSkillSvg fileName={skill.fileName} theme={theme} />
            </div>
          </Fade>

          <div className="skills-text-div">
            <Fade right duration={1000}>
              <h1 className="skills-heading" style={{ color: theme.text }}>
                {t(skill.titleKey)}
              </h1>
            </Fade>

            <Fade right duration={1500}>
              <SoftwareSkill logos={skill.softwareSkills} />
            </Fade>

            <Fade right duration={2000}>
              <div>
                {skill.skillsKeys.map((key, idx) => (
                  <p
                    key={idx}
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t(key)}
                  </p>
                ))}
              </div>
            </Fade>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SkillSection;